import api from './api';

export interface TenantEmailRemitente {
  tipoDocumento: string;
  fromEmail: string;
  fromName?: string | null;
  confirmado?: boolean;
  pendienteConfirmacion?: boolean;
}

export interface TenantEmailSettingsStatus {
  configurado: boolean;
  fromEmail?: string | null;
  fromName?: string | null;
  smtpServer?: string | null;
  smtpPort?: number | null;
  enableSsl?: boolean | null;
  username?: string | null;
  tieneContrasena: boolean;
  contrasenaLegible?: boolean;
  actualizadoEn?: string | null;
  actualizadoPor?: string | null;
  remitentes?: TenantEmailRemitente[];
}

export interface TenantEmailSettingsSave {
  smtpServer: string;
  smtpPort: number;
  username: string;
  appPassword?: string;
  fromEmail?: string;
  fromName?: string;
  enableSsl: boolean;
}

export interface TenantEmailRemitentesSave {
  remitentes: TenantEmailRemitente[];
}

const tenantEmailSettingsService = {
  async getStatus(): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.get<TenantEmailSettingsStatus>('/api/tenant/email-settings');
    return data;
  },

  async save(payload: TenantEmailSettingsSave): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.put<TenantEmailSettingsStatus>('/api/tenant/email-settings', payload);
    return data;
  },

  async saveRemitentes(payload: TenantEmailRemitentesSave): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.put<TenantEmailSettingsStatus>(
      '/api/tenant/email-settings/remitentes',
      payload
    );
    return data;
  },

  async confirmRemitente(tipoDocumento: string, codigo: string): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.post<TenantEmailSettingsStatus>(
      `/api/tenant/email-settings/remitentes/${encodeURIComponent(tipoDocumento)}/confirmar`,
      { codigo }
    );
    return data;
  },

  async resendCodigo(tipoDocumento: string): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.post<TenantEmailSettingsStatus>(
      `/api/tenant/email-settings/remitentes/${encodeURIComponent(tipoDocumento)}/reenviar-codigo`
    );
    return data;
  },

  async removeRemitente(tipoDocumento: string): Promise<TenantEmailSettingsStatus> {
    const { data } = await api.delete<TenantEmailSettingsStatus>(
      `/api/tenant/email-settings/remitentes/${encodeURIComponent(tipoDocumento)}`
    );
    return data;
  },

  async remove(): Promise<void> {
    await api.delete('/api/tenant/email-settings');
  },

  async testSmtp(email: string): Promise<{ message: string }> {
    const { data } = await api.post<{ message: string }>('/api/tenant/email-settings/test', { email });
    return data;
  },
};

export default tenantEmailSettingsService;
